__turbopack_context__.v({
  "salesBanner": "SalesBanner-module-scss-module__Dec8iq__salesBanner",
  "salesBannerButton": "SalesBanner-module-scss-module__Dec8iq__salesBannerButton",
  "salesBannerContainer": "SalesBanner-module-scss-module__Dec8iq__salesBannerContainer",
  "salesBannerContent": "SalesBanner-module-scss-module__Dec8iq__salesBannerContent",
  "salesBannerSubtitle": "SalesBanner-module-scss-module__Dec8iq__salesBannerSubtitle",
  "salesBannerTimer": "SalesBanner-module-scss-module__Dec8iq__salesBannerTimer",
  "salesBannerTitle": "SalesBanner-module-scss-module__Dec8iq__salesBannerTitle",
  "timerItem": "SalesBanner-module-scss-module__Dec8iq__timerItem",
  "timerLabel": "SalesBanner-module-scss-module__Dec8iq__timerLabel",
  "timerSeparator": "SalesBanner-module-scss-module__Dec8iq__timerSeparator",
  "timerValue": "SalesBanner-module-scss-module__Dec8iq__timerValue",
});
